export class EngineeredJointInputData {
    flangeMaterialId1: string;
    flangeMaterialId2: string;
    gasketId: string;
    nutDimensionId: string;
    boltMaterialId: string;
    threadType: string;
    boltDimensionId: string;
    boltType: number;
    boltQuantity: number;
    jointThickness: string;
    boltHoleDiameter: string;
    gasketCompThickness: string;
    tighteningSpecification: string;
    tighteningSpecificationInput: string;
    jointConfiguration: string;
    minimumBoltDiameter: string;
    isDataValid: boolean;
    isRedAreaBoltSelected: boolean;
    pAdditional?: number;
    boltMaterialAliasId?: string;
    flangeMaterialAliasId1?: string;
    flangeMaterialAliasId2?: string;
    gasketAliasId?:string;

}
